import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledContactUs = styled.svg<IconProps>`
  & .cls-1 {
    fill: var(--du-color-white);
  }

  & .cls-2 {
    fill: var(--du-color-grey);
  }

  & .cls-3 {
    fill: #fff;
    stroke: var(--du-color-grey);
  }

  & .cls-4 {
    fill: #fff;
    stroke: var(--du-color-grey);
  }

  & .cls-5 {
    filter: url(#Ellipse_3);
  }

  &.hover:hover,
  &.active {
    .cls-1,
    .cls-3 {
      fill: var(--du-color-primary);
    }

    .cls-2 {
      fill: var(--du-color-grey-pale);
    }

    .cls-3,
    .cls-4 {
      stroke: var(--du-color-grey-pale);
    }

    .cls-3 {
      stroke-linejoin: round;
      stroke-width: 1.5px;
    }

    .cls-4 {
      fill: none;
    }
  }
`;

const ContactUsIcon: React.FC<IconProps> = ({ active }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledContactUs
      id='Contact-Us-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <g id='Contact_Us' data-name='Contact Us' transform='translate(16 16)'>
        <g id='Group_17497' data-name='Group 17497' transform='translate(-16 -16)'>
          <circle id='Ellipse_3-2' data-name='Ellipse 3-2' className='cls-1' cx='16' cy='16' r='16' />
          <g id='mail' transform='translate(7.326 12.525)'>
            <path
              id='Vector'
              className='cls-2'
              d='M15.429,12.816H.571A.577.577,0,0,1,0,12.234V.582A.577.577,0,0,1,.571,0H15.429A.577.577,0,0,1,16,.582V12.234A.577.577,0,0,1,15.429,12.816ZM1.192,1.943h0l.092.072,0,9.49H14.714V2.017L8.611,6.85a.984.984,0,0,1-1.227,0l-6.1-4.833Zm.3-1.236h0L1.638.82l.621.493L8,5.862l5.74-4.549.766-.606.7.919-.493.391.5-.391-.7-.92-.764.6-11.483,0L1.638.82,1.495.706Zm0,0-.7.916.4.318h0l-.4-.317Z'
              transform='translate(0.675 0.2)'
            />
            <path
              id='Path_15966'
              data-name='Path 15966'
              className='cls-3'
              d='M17.031,14.76l5.41,4.167L28,14.76V7.093H17.031Z'
              transform='translate(-13.816 -12.167)'
            />
            <line id='Line_398' data-name='Line 398' className='cls-4' x2='7.758' transform='translate(4.818 -2.118)' />
            <line id='Line_399' data-name='Line 399' className='cls-4' x2='5.968' transform='translate(4.818 -0.105)' />
            <line id='Line_400' data-name='Line 400' className='cls-4' x2='4.844' transform='translate(4.818 1.907)' />
          </g>
        </g>
      </g>
    </StyledContactUs>
  );
};

export default ContactUsIcon;
